module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/static/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3567c3b67c676ac8f534d1f05e458ede"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
